import { WsSelect, WsSelectObj } from 'wisestep-base';

import { FilterSetValueProps } from '../models';

import WsAccordion from './WsAccordion';

const JobBoardFilter = ({ name }: FilterSetValueProps) => (
  <WsAccordion title="Posted On Job Board">
    <WsSelect name={name} selectArray={options} placeholder="Select" />
  </WsAccordion>
);
export default JobBoardFilter;

const options: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'CWjobs',
    value: 'CWjobs',
  },
  {
    label: 'CareerJet',
    value: 'CareerJet',
  },
  {
    label: 'CareersPage',
    value: 'CareersPage',
  },
  {
    label: 'Dice',
    value: 'Dice',
  },
  {
    label: 'GoogleJobs',
    value: 'GoogleJobs',
  },
  {
    label: 'Indeed',
    value: 'indeed',
  },
  {
    label: 'JobInventory',
    value: 'JobInventory',
  },
  {
    label: 'Jobisite',
    value: 'Jobisite',
  },
  {
    label: 'Jobomas',
    value: 'Jobomas',
  },
  {
    label: 'JobTarget',
    value: 'JobTarget',
  },
  {
    label: 'Jobvertise',
    value: 'Jobvertise',
  },
  {
    label: 'Jooble',
    value: 'jooble',
  },
  {
    label: 'Jora',
    value: 'Jora',
  },
  {
    label: 'Jora Qatar',
    value: 'joraQatar',
  },
  {
    label: 'Jora UAE',
    value: 'joraUAE',
  },
  {
    label: 'Jora UK',
    value: 'joraUK',
  },
  {
    label: 'Jora US',
    value: 'joraUS',
  },
  {
    label: 'Learn4good',
    value: 'Learn4good',
  },
  {
    label: 'Lensa',
    value: 'Lensa',
  },
  {
    label: 'Lensa US',
    value: 'lensaUS',
  },
  {
    label: 'Monster',
    value: 'monster',
  },
  {
    label: 'Monster Organic',
    value: 'MonsterOrganic',
  },
  {
    label: 'Neuvoo',
    value: 'Neuvoo',
  },
  {
    label: 'Oodle',
    value: 'Oodle',
  },
  {
    label: 'Postjobfree',
    value: 'Postjobfree',
  },
  {
    label: 'TechFetch',
    value: 'techfetch',
  },
  {
    label: 'What Jobs',
    value: 'WhatJobs',
  },
  {
    label: 'Ziprecruiter',
    value: 'Ziprecruiter',
  },
  {
    label: 'Talent',
    value: 'Talent',
  },
];
